import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';

/** Same choice as the report editor: Annuller, Nej, Ja. */
export function SaveBeforeLeaveModal({
  open,
  title,
  description,
  saving = false,
  onStay,
  onDiscard,
  onSave,
  stayLabel,
  discardLabel,
  saveLabel,
}: {
  open: boolean;
  title: string;
  description: string;
  saving?: boolean;
  onStay: () => void;
  onDiscard: () => void;
  onSave: () => void;
  stayLabel: string;
  discardLabel: string;
  saveLabel: string;
}) {
  return (
    <Modal
      open={open}
      title={title}
      description={description}
      onClose={onStay}
      tone="warning"
      showIcon
      role="alertdialog"
      footer={
        <>
          <Button type="button" variant="ghost" onClick={onStay} disabled={saving}>
            {stayLabel}
          </Button>
          <Button type="button" variant="secondary" onClick={onDiscard} disabled={saving}>
            {discardLabel}
          </Button>
          <Button type="button" loading={saving} onClick={onSave}>
            {saveLabel}
          </Button>
        </>
      }
    >
      {null}
    </Modal>
  );
}
